import classNames from 'classnames';

import style from './TaskUrgencyBadge.module.scss';

import { TaskUrgency } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';
import WarningIcon from '@components/Icon/svg/warning.svg';
import { translate } from '@chaika/i18n/helper';

interface Props {
    urgency?: TaskUrgency;
    className?: string;
}

export function TaskUrgencyBadge({ urgency, className }: Props): React.ReactElement<any> | null {
    const isUrgent = isDefined(urgency) && urgency !== TaskUrgency.Routine;

    return isUrgent ? (
        <div className={classNames([style.badge, className])}>
            <WarningIcon className={style.icon} />
            {translate('executeUrgently')}
        </div>
    ) : null;
}
